import React, { useState, useEffect } from 'react';
import { useApi } from '../../../../context/ApiContext/ApiContext';
import { ThemeProvider } from '../../themes/ThemeProvider';
import { processEndpointValues, restructureObject } from '../moduleUtils/apiObjectFormatting';
import FormField from '../../featureOverlay/baseElements/FormField';
import ModuleContainer from '../../featureOverlay/baseElements/ModuleContainer';
import ModuleHeader from '../../featureOverlay/baseElements/ModuleHeader';
import ModuleDescription from '../../featureOverlay/baseElements/ModuleDescription';
import ModuleBody from '../../featureOverlay/baseElements/ModuleBody';
import InfoComponent from '../../elements/InfoComponent';
import ButtonComponent from '../../elements/ButtonComponent';
import { moduleConfig } from './channelCreateConfig';

const ChannelCreate = ({ id, data }) => {
  // API CALL CONTEXT
  const { moduleNodes, registerModule, updateModuleConfig, updateApiParams, setExecutionOrder, toggleModuleActive, sharedParams, state } = useApi();
  const [endpointValues, setEndpointValues] = useState(() => {
    return moduleNodes[id] || 
      {
  "endpoint_0": {
    "path": "/api2/channel/create",
    "method": "POST",
    "root_url": "https://services.uplynk.com",
    "params": {
      "desc": "test_1",
      "slicer_id": "test_1",
      "require_drm": "0",
      "require_studio_drm": "0"
    }
  }
};
});
  const [results, setResults] = useState(null);
  const [isModified, setIsModified] = useState(false);

  useEffect(() => {
    console.log("ChannelCreate - state: ", state);
  }, [state])
  
  // Handle form field changes by updating the specific endpoint parameter directly
  const handleChange = (endpointKey, paramName, value) => {
    setEndpointValues(prev => ({
      ...prev,
      [endpointKey]: {
        ...prev[endpointKey],
        params: {
          ...prev[endpointKey].params,
          [paramName]: value
        }
      }
    }));
    setIsModified(true);
  };

  // Handle form submission with API context integration
  const handleSubmit = async () => {
    try {
      // Process the endpoint values
      const processedData = processEndpointValues(endpointValues, moduleConfig);
    
      // Update the module's configuration
      updateModuleConfig(id, processedData.endpoints, processedData.validation);
      setIsModified(false);
      console.log("processedData.endpoints", processedData.endpoints);
    } catch (error) {
      console.error('Error processing form:', error);
    }
  };

    // Register module on mount
  useEffect(() => {
    if (!id) return;

    if (!moduleNodes[id]) {
      const moduleLabel = data?.label || '';

      // Process the endpoint values to get validation results
      const processedData = processEndpointValues(endpointValues, moduleConfig);
      
      // Create the full module data including callbacks
      const moduleData = {
        ...endpointValues,
        callbacks: moduleConfig.moduleConfig.callbacks, // Include callbacks from the module config
      };
      
      // Register module with all data including callbacks
      registerModule(id, moduleData, moduleLabel, processedData.validation);
      // registerModule(id, endpointValues);
    } else {
      // If module exists, use its data including any callbacks
      setEndpointValues(moduleNodes[id]);

    }

    // Clean up when component unmounts
    return () => {
      // If you want to remove this module when the component unmounts
      // removeModule(nodeId);
    };
  }, []);

  return (
      <ThemeProvider themeKey="uplynk" size="tiny">
        <ModuleContainer>
          <ModuleHeader title="Channel Creator" />
          <ModuleDescription description="" />
          <ModuleBody endpoints={moduleConfig.moduleConfig.endpoints} readyState={moduleNodes[id]?.readyState && !isModified} activeState={moduleNodes[id]?.activeState} toggleModuleActive={toggleModuleActive} id={id}>
              {/* Field: desc for /api2/channel/create */}
                <FormField 
                  type="text"
                  label="Title"
                  value={endpointValues['endpoint_0']?.params?.['desc']}
                  onChange={(value) => handleChange('endpoint_0', 'desc', value)}
                  required={true}
                  placeholder="Sports Channel"
                  
                />

              {/* Field: slicer_id for /api2/channel/create */}
                <FormField 
                  type="text"
                  label="Encoder ID"
                  value={endpointValues['endpoint_0']?.params?.['slicer_id']}
                  onChange={(value) => handleChange('endpoint_0', 'slicer_id', value)}
                  
                  placeholder="srt_slicer_1"
                  
                />

              {/* Field: require_drm for /api2/channel/create - Integer Checkbox */}
                <FormField 
                  type="checkbox"
                  label="Token"
                  value={!!endpointValues['endpoint_0']?.params?.['require_drm']}
                  onChange={(checked) => handleChange('endpoint_0', 'require_drm', checked ? 1 : 0)}
                  
                  
                />

              {/* Field: require_studio_drm for /api2/channel/create - Integer Checkbox */}
                <FormField 
                  type="checkbox"
                  label="DRM"
                  value={!!endpointValues['endpoint_0']?.params?.['require_studio_drm']}
                  onChange={(checked) => handleChange('endpoint_0', 'require_studio_drm', checked ? 1 : 0)}
                  
                  
                />

              {/* Button: button_1741972236175 */}
              <ButtonComponent 
                id="button_1741972236175"
                label="Apply" 
                variant="primary"
                onClick={handleSubmit}
              />
          </ModuleBody>
        </ModuleContainer>
      </ThemeProvider>
    );
}

export default ChannelCreate;